import { Component, OnInit } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
    selector: 'modal-content',
    styleUrls: ['./modalcontent.component.scss'],
    templateUrl: './modalcontent.component.html'
})
export class ModalContentComponent implements OnInit {
    public title: string;
    public content: string;
    public list: any[] = [];

    constructor(public bsModalRef: BsModalRef) {}

    public ngOnInit() {
        console.log('BsModalRef from modal content component', this.bsModalRef);
    }
}
